/**
 * Pick-session mode enums extracted from
 * `redo/model/src/wms/schema/pick-session.ts` so leaf packages (and the
 * OutboundLabelSettings slice) can reference them without a model↔leaf cycle.
 * The rest of `pick-session.ts` (schemas depending on the model
 * inventory-source) stays in redo/model and re-imports these.
 *
 * Persisted to Mongo — keep in sync with the `typedEnum` registration in
 * `redo/backend/db/schema/src/team/OutboundLabelSettings.ts`.
 */
export enum ScanType {
  SCAN_AT_CART = "scan_at_cart",
  SCAN_AT_WALL = "scan_at_wall",
}

export enum PickSessionStrategy {
  SINGLE_ITEM = "single_item",
  MULTI_ITEM = "multi_item",
  // BULK_SHIPMENT = "bulk_shipment",
}
